import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "posFi blackbrownBg fs11 fw600 pad5",
  style: {"top":"100px","z-index":"1"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  key: 3,
  class: /*#__PURE__*/_normalizeClass(`ScheduleCenterContent mt20`)
}
const _hoisted_6 = {
  class: "centered posAb",
  style: {"bottom":"0","margin":"10px 45%"}
}
const _hoisted_7 = { class: "roomMessagesHeader pad10 w100 rurad8 rad12-top" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "w100 fw600 fs12 alertBg pad5",
  style: {"height":"45px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_LinkHeader = _resolveComponent("LinkHeader")!
  const _component_InstantRoomContent = _resolveComponent("InstantRoomContent")!
  const _component_CalendarPinkButton = _resolveComponent("CalendarPinkButton")!
  const _component_AppointmentCardViewLarge = _resolveComponent("AppointmentCardViewLarge")!
  const _component_ScheduleAppealContent = _resolveComponent("ScheduleAppealContent")!
  const _component_ScheduleMainContent = _resolveComponent("ScheduleMainContent")!
  const _component_AssignFormMainContent = _resolveComponent("AssignFormMainContent")!
  const _component_ScheduleUnderContent = _resolveComponent("ScheduleUnderContent")!
  const _component_CalendarsMenu = _resolveComponent("CalendarsMenu")!
  const _component_RoomMembersMenu = _resolveComponent("RoomMembersMenu")!
  const _component_IconLock = _resolveComponent("IconLock")!
  const _component_RoomMessages = _resolveComponent("RoomMessages")!
  const _component_ModalInputMessage = _resolveComponent("ModalInputMessage")!
  const _component_DataContent = _resolveComponent("DataContent")!
  const _component_FixLoadingModal = _resolveComponent("FixLoadingModal")!
  const _component_ImagePreviewModal = _resolveComponent("ImagePreviewModal")!
  const _component_NewMessageModal = _resolveComponent("NewMessageModal")!
  const _component_FilledScheduleModal = _resolveComponent("FilledScheduleModal")!
  const _component_FormContentModal = _resolveComponent("FormContentModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    (!_ctx.isGuest)
      ? (_openBlock(), _createBlock(_component_LinkHeader, {
          key: 0,
          pageTitle: _ctx.isPreview ? `クラウド日程調整（プレビュー）` : `クラウド日程調整`,
          buttonTitle: null,
          buttonEnabled: true,
          showWhatCal: false,
          showBackButton: !_ctx.isGuest && !_ctx.isPreview,
          isSuspend: _ctx.pdm.isSuspend || true,
          onClickPinkButton: _ctx.goAvailableScheduleView
        }, null, 8, ["pageTitle", "showBackButton", "isSuspend", "onClickPinkButton"]))
      : _createCommentVNode("", true),
    (_ctx.isEmbedsInstantButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_InstantRoomContent, { onClickInstantButton: _ctx.clickInstantButton }, null, 8, ["onClickInstantButton"])
        ]))
      : (_ctx.type)
        ? (_openBlock(), _createElementBlock("section", {
            key: 2,
            class: _normalizeClass(`AvailableTimeContent posAb`),
            style: _normalizeStyle({
                display: `flex`,
                justifyContent: `center`,
                marginTop: _ctx.isGuest ? `0` : `68px`,
            })
          }, [
            (_ctx.isPreview)
              ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                  _createTextVNode(" プレビュー中（お相手に見える画面です） "),
                  _hoisted_4,
                  _createTextVNode("候補日時は実際と異なる場合があります。 ")
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isSP && _ctx.showPinkButton)
              ? (_openBlock(), _createBlock(_component_CalendarPinkButton, {
                  key: 1,
                  room: _ctx.room,
                  appo: _ctx.appo,
                  pdm: _ctx.pdm
                }, null, 8, ["room", "appo", "pdm"]))
              : _createCommentVNode("", true),
            (_ctx.showCardView())
              ? (_openBlock(), _createBlock(_component_AppointmentCardViewLarge, {
                  key: 2,
                  appo: _ctx.appo,
                  type: _ctx.type,
                  userType: _ctx.userType,
                  isPreview: _ctx.isPreview,
                  naType: _ctx.naType,
                  ref: "cardViewLarge"
                }, null, 8, ["appo", "type", "userType", "isPreview", "naType"]))
              : _createCommentVNode("", true),
            (_ctx.type != `na` && (!_ctx.isSP || [`schedule`, `apc`].includes(_ctx.selectedTab)))
              ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                  (_ctx.showHeader())
                    ? (_openBlock(), _createBlock(_component_ScheduleAppealContent, {
                        key: 0,
                        room: _ctx.room,
                        isSuspend: _ctx.pdm.isSuspend,
                        additionalParams: _ctx.additionalParams
                      }, null, 8, ["room", "isSuspend", "additionalParams"]))
                    : _createCommentVNode("", true),
                  (_ctx.showMainContent())
                    ? (_openBlock(), _createBlock(_component_ScheduleMainContent, {
                        key: 1,
                        ref: "ScheduleMainContent",
                        appo: _ctx.appo,
                        type: _ctx.type,
                        room: _ctx.room,
                        parentId: _ctx.parentId,
                        getPossibles: _ctx.getPossibles,
                        showFilledScheduleModal: _ctx.showFilledScheduleModal,
                        resetPossibleDates: _ctx.resetPossibleDates,
                        loading: _ctx.gettingPds,
                        onAddNewAppo: _ctx.addNewAppo
                      }, null, 8, ["appo", "type", "room", "parentId", "getPossibles", "showFilledScheduleModal", "resetPossibleDates", "loading", "onAddNewAppo"]))
                    : _createCommentVNode("", true),
                  (_ctx.showAssignForm())
                    ? (_openBlock(), _createBlock(_component_AssignFormMainContent, {
                        key: 2,
                        room: _ctx.room,
                        loading: _ctx.gettingPds
                      }, null, 8, ["room", "loading"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ScheduleUnderContent)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isSP && _ctx.showCardView() && _ctx.fullwindow && _ctx.type != `na`)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: _normalizeClass(`ScheduleFixMarginContent ofh ${_ctx.isSP ? `pad20 with_white_bg` : `pad20`} posRe ${
                    _ctx.rm.designType() == `normal` ? `` : `nodisp`
                }`)
                }, "   ", 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", {
                href: "https://link.waaq.jp",
                target: "_blank",
                class: "grey fs12",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickWaaqmark && _ctx.clickWaaqmark(...args)))
              }, "© " + _toDisplayString(_ctx.Const.year) + " waaq Inc.", 1)
            ])
          ], 4))
        : _createCommentVNode("", true),
    _createVNode(_component_CalendarsMenu, {
      isPublic: _ctx.Util.isPublic(),
      getPossibles: _ctx.getPossibles,
      resetPossibleDates: _ctx.resetPossibleDates
    }, null, 8, ["isPublic", "getPossibles", "resetPossibleDates"]),
    (!_ctx.isPreview && _ctx.type != `na`)
      ? (_openBlock(), _createBlock(_component_RoomMembersMenu, {
          key: 3,
          room: _ctx.room,
          selectedTab: _ctx.selectedTab,
          onSelectedRoom: _ctx.selectMessageRoom,
          onSelectTab: _ctx.selectTab
        }, null, 8, ["room", "selectedTab", "onSelectedRoom", "onSelectTab"]))
      : _createCommentVNode("", true),
    (!_ctx.isPreview && _ctx.room && _ctx.room.room_setting && _ctx.room.room_setting.use_chat && !_ctx.Util.isEmbeds())
      ? (_openBlock(), _createElementBlock("section", {
          key: 4,
          class: _normalizeClass(`roomMessagesContent ${_ctx.openHeader ? `open` : `close`}`),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectMessageContent && _ctx.selectMessageContent(...args))),
          style: _normalizeStyle({
                right: _ctx.Util.isPublic() && !_ctx.isSP ? `20px` : ``,
            })
        }, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.rm.currentMessageRoom && _ctx.rm.currentMessageRoom.title)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "fs14 fw600 fl pointer",
                  style: _normalizeStyle({
                        width: _ctx.isSP ? `240px` : `340px`,
                        margin: `10px 0 0 10px`,
                    })
                }, [
                  (!_ctx.rm.currentMessageRoom.isParent)
                    ? (_openBlock(), _createBlock(_component_IconLock, {
                        key: 0,
                        is_white: true
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.truncate(_ctx.rm.currentMessageRoom.title, 28)), 1)
                ], 4))
              : _createCommentVNode("", true),
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/popUp/close_white.png`),
              width: "30",
              height: "30",
              class: "fr pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeMessageHeader && _ctx.closeMessageHeader(...args)))
            }, null, 8, _hoisted_8)
          ])), [
            [
              _directive_tooltip,
              _ctx.tooltipName,
              void 0,
              { top: true }
            ]
          ]),
          (_ctx.pdm.isSuspend)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, " オーナーが停止中のアカウントため、新規のメッセージを送信できません。 "))
            : _createCommentVNode("", true),
          _hoisted_10,
          _createVNode(_component_RoomMessages, {
            ref: "roomMessagesView",
            isSuspend: _ctx.pdm.isSuspend,
            onShowPreview: _ctx.showImagePreview
          }, null, 8, ["isSuspend", "onShowPreview"])
        ], 6))
      : _createCommentVNode("", true),
    (_ctx.isSP)
      ? (_openBlock(), _createBlock(_component_ModalInputMessage, {
          key: 5,
          onSendFromModal: _ctx.sendFromModal
        }, null, 8, ["onSendFromModal"]))
      : _createCommentVNode("", true),
    _createVNode(_component_DataContent, { onUpdateDataFromRails: _ctx.updateDataFromRails }, null, 8, ["onUpdateDataFromRails"]),
    _createVNode(_component_FixLoadingModal),
    _createVNode(_component_ImagePreviewModal, { file: _ctx.currentFile }, null, 8, ["file"]),
    _createVNode(_component_NewMessageModal, {
      ref: "NewMessageModal",
      room: _ctx.room
    }, null, 8, ["room"]),
    _createVNode(_component_FilledScheduleModal, { onClickOK: _ctx.clickOKFilledSchedule }, null, 8, ["onClickOK"]),
    _createVNode(_component_FormContentModal, { pd: _ctx.instantRoomPd }, null, 8, ["pd"])
  ]))
}